<template>
  <b-row>
    <b-col>
      <b-card>
        <template #header>
          <h4 class="card-title">
            Device List
          </h4>
        </template>
        <div>
          <b-table
            class="datatables-custom"
            primary-key="id"
            :items="devices"
            :fields="tableFields"
            responsive
            bordered
            stacked="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :busy="isLoading"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-sort-reset
          >
            <template #empty>
              <div class="text-center">
                Sorry, device were not found.
              </div>
            </template>
            <template v-slot:cell(name)="row">
              <router-link
                :to="{
                  name: 'device-detail',
                  params: {
                    deviceId: row.item.id,
                  },
                }"
                class="link-item-table custom-link"
              >
                {{ row.item.name }}
              </router-link>
            </template>
            <template v-slot:cell(is_connected)="row">
              <div class="d-flex align-items-center">
                <div
                  class="me-2"
                  :class="{
                    'bg-success': row.item.is_connected,
                    'bg-danger': !row.item.is_connected,
                  }"
                  style="width: 10px; height: 10px; border-radius: 50%"
                />
                <div>
                  <timeago
                    :datetime="row.item.last_uplink_at"
                    :auto-update="60"
                  />
                </div>
              </div>
            </template>
            <template v-slot:cell(type)="row">
              <div class="text-capitalize">
                {{ row.item.type.replace(/_/g, ' ') }}
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    devices: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      title: 'Devices',
      items: [
        {
          text: 'Device List',
          active: true,
        },
      ],
      tableFields: [
        {
          key: 'name',
          label: 'Device Name',
          thStyle: {
            minWidth: '6rem',
          },
          class: 'text-break',
          sortable: true,
        },
        {
          key: 'device_id',
          label: 'Device ID',
          thStyle: {
            minWidth: '6rem',
          },
          class: 'text-break',
          sortable: true,
        },
        {
          key: 'type',
          label: 'Device Type',
          thStyle: {
            minWidth: '6rem',
          },
        },
        {
          key: 'is_connected',
          label: 'Status',
          thStyle: {
            minWidth: '20rem',
          },
        },
      ],
      currentPage: 1,
      perPage: 10,
      isLoading: false,
      sortBy: '',
      sortDesc: false,
    };
  },
};
</script>

<style>

</style>
